/** Projectstatus zoals de gebruiker hem ziet. 'planning' = strategie al opstarten vóór de start van het project. */
export const PROJECT_STATUS_LABELS: Record<string, string> = {
  planning: 'In afwachting',
  active: 'Actief',
  paused: 'Gepauzeerd',
  completed: 'Afgerond',
  cancelled: 'Geannuleerd',
};
export const projectStatusLabel = (status?: string): string => (status && PROJECT_STATUS_LABELS[status]) || status || '';

/** Gebruikersrol: wat iemand in het beheer mag. Staat los van de rol in een project. */
export const USER_ROLE_LABELS: Record<string, string> = {
  superAdmin: 'Superbeheerder',
  admin: 'Beheerder',
  projectManager: 'Projectleider',
  stakeholder: 'Stakeholder',
  viewer: 'Lezer',
};

/** Rol binnen één project. */
export const PROJECT_ROLE_LABELS: Record<string, string> = {
  manager: 'Projectleider',
  member: 'Teamlid',
  viewer: 'Meekijker',
};
